<div [formGroup]="formGroup">
  <dgx-dfb-select
    [formControlName]="field.controlName"
    [field]="field"
  ></dgx-dfb-select>
</div>
